<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab" @tab-click="handleClick">
      <el-tab-pane label="标签包管理" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>所属项目：</label>
                <el-select
                  v-model="searchForm.pid"
                  remote
                  clearable
                  :size="size"
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="getProjectLists"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <!-- <div class="k-close-icon">
                                    <i class="el-icon-close" @click="resetStatus"></i>
                </div>-->
              </div>
            </div>
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>标签包名称：</label>
                <el-select
                  v-model="searchForm.tagName"
                  placeholder="请输入标签包名称"
                  :size="size"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethodTag"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in nameOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <el-button :size="size" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar">
                <div>
                  <el-button
                    :size="size"
                    type="primary"
                    icon="el-icon-user"
                    @click="addTagsOpen"
                  >新增标签包</el-button>
                </div>
              </div>
              <div class="k-table-con">
                <el-table :data="tableData.data" border style="width: 100%">
                  <el-table-column fixed="left" prop="id" label="ID" width="100"></el-table-column>
                  <el-table-column prop="project" label="所属项目" width="200"></el-table-column>
                  <el-table-column fixed="left" prop="name" label="标签包名称" width="200"></el-table-column>
                  <el-table-column prop="remark" label="备注" width="300"></el-table-column>
                  <el-table-column prop="tags" label="标签" width="300">
                    <template slot-scope="scope">
                      <el-tag
                        :key="tag"
                        v-for="tag in scope.row.tags"
                        :size="size"
                        style="margin-right:5px"
                      >{{tag}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="create_time" label="创建时间" width="200"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        :size="size"
                        class="c-danger"
                        @click="editTagsOpen(scope.row.id)"
                      >编辑</el-button>
                      <el-button
                        type="text"
                        :size="size"
                        style="color:red"
                        @click="delTag(scope.row)"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number"
                  :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="标题包管理" name="second">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>所属项目</label>
                <el-select
                  style="width: 100%"
                  v-model="searchForm.pid"
                  :size="size"
                  clearable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="getProjectLists"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>标题包名称：</label>
                <el-select
                  v-model="searchForm.titleName"
                  placeholder="请输入标题包名称"
                  :size="size"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethodTag"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in titleOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <el-button :size="size" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar">
                <div>
                  <el-button
                    :size="size"
                    type="primary"
                    icon="el-icon-user"
                    @click="addTitlesOpen"
                  >新增标题包</el-button>
                </div>
              </div>
              <div class="k-table-con">
                <el-table :data="titleData.data" border style="width: 100%">
                  <el-table-column fixed="left" prop="id" label="ID" width="100"></el-table-column>
                  <el-table-column prop="project" label="所属项目" width="200"></el-table-column>
                  <el-table-column fixed="left" prop="name" label="标题包名称" width="200"></el-table-column>
                  <el-table-column prop="remark" label="备注" width="300"></el-table-column>
                  <el-table-column prop="tags" label="标题" width="300">
                    <template slot-scope="scope">
                      <el-tag
                        :key="tag"
                        v-for="tag in scope.row.tags"
                        :size="size"
                        style="margin-right:5px"
                      >{{tag}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="create_time" label="创建时间" width="200"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        :size="size"
                        class="c-danger"
                        @click="editTitlesOpen(scope.row.id)"
                      >编辑</el-button>
                      <el-button
                        type="text"
                        :size="size"
                        style="color:red"
                        @click="delTitle(scope.row)"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="titleData.current_page | number"
                  :page-size="titleData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="titleData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="计划模板管理" name="third">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>所属项目</label>
                <el-select
                  style="width: 100%"
                  v-model="searchForm.pid"
                  :size="size"
                  clearable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="getProjectLists"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>营销目标</label>
                <el-select
                  v-model="searchForm.marketing_goal"
                  placeholder="不限"
                  :size="size"
                  clearable
                >
                  <el-option
                    v-for="item in marketing_goal_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>推广方式</label>
                <el-select
                  v-model="searchForm.promotion_way"
                  placeholder="不限"
                  :size="size"
                  clearable
                >
                  <el-option
                    v-for="item in promotion_way_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>计划模板名称：</label>
                <el-select
                  v-model="searchForm.templateName"
                  placeholder="请输入计划模板名称"
                  :size="size"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethodTag"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in templateOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <el-button :size="size" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-con">
                <el-table :data="templateData.data" border style="width: 100%">
                  <el-table-column fixed="left" prop="id" label="ID" width="100"></el-table-column>
                  <el-table-column prop="project" label="所属项目" width="200"></el-table-column>
                  <el-table-column fixed="left" prop="name" label="计划模板名称" width="200"></el-table-column>
                  <el-table-column prop="remark" label="备注" width="300"></el-table-column>
                  <el-table-column prop="marketing_goal" label="营销目标" width="150">
                    <template slot-scope="scope">
                      <el-tag
                        :key="tag.value"
                        v-for="tag in marketing_goal_options"
                        v-if="tag.value == scope.row.marketing_goal"
                        :size="size"
                        style="margin-right:5px"
                      >{{tag.label}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="promotion_way" label="推广方式" width="150">
                    <template slot-scope="scope">
                      <el-tag
                        :key="tag.value"
                        v-for="tag in promotion_way_options"
                        v-if="tag.value == scope.row.promotion_way"
                        :size="size"
                        style="margin-right:5px"
                      >{{tag.label}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="aweme_id" label="抖音ID" width="200">
                    <template slot-scope="scope">
                      <el-tag :size="size">{{scope.row.aweme_id}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="product_ids" label="商品ID" width="200">
                    <template slot-scope="scope">
                      <el-tag :size="size">{{scope.row.product_ids}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="create_time" label="创建时间" width="200"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        :size="size"
                        style="color:red"
                        @click="delTemplate(scope.row)"
                      >删除</el-button>
                      <!-- <el-button type="text" :size="size" class="c-danger">编辑</el-button> -->
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="templateData.current_page | number"
                  :page-size="templateData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="templateData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 打开新增标签包 -->
    <el-drawer
      custom-class="k-drawer"
      :wrapperClosable="wrapper"
      :visible.sync="addFormVisiable"
      direction="rtl"
      size="50%"
    >
      <el-form
        :model="addForm"
        ref="addForm"
        :rules="rules.addForm"
        label-width="110px"
        :size="size"
      >
        <div class="drawer-header">
          <div class="header-title">
            <span v-if="tagType == 'add'">新增标签包</span>
            <span v-if="tagType == 'edit'">修改标签包</span>
            <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="所属项目:" prop="pid">
            <el-select
              style="width: 100%"
              v-model="addForm.pid"
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getProjectLists"
            >
              <el-option
                v-for="item in projects"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签包名称:" prop="name">
            <el-input placeholder="请输入账户名称" v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="标签包备注:">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入备注内容"
              v-model="addForm.remark"
            ></el-input>
          </el-form-item>
          <el-form-item label="标签:" prop="dynamicTags">
            <el-tag
              style="margin-right:5px"
              :key="tag"
              v-for="tag in addForm.dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >{{tag}}</el-tag>
            <el-input
              style="width:80px"
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button :size="size" v-else class="button-new-tag" @click="showInput">+创 建</el-button>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" v-if="tagType == 'add'" @click="addTags" :size="size">提交</el-button>
          <el-button type="primary" v-if="tagType == 'edit'" @click="editTags" :size="size">修改</el-button>
          <el-button :size="size" @click="addFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
    <!-- 打开新增标题包 -->
    <el-drawer
      custom-class="k-drawer"
      :wrapperClosable="wrapper"
      :visible.sync="titleFormVisiable"
      direction="rtl"
      size="50%"
    >
      <el-form
        :model="titleForm"
        ref="titleForm"
        :rules="rules.titleForm"
        label-width="110px"
        :size="size"
      >
        <div class="drawer-header">
          <div class="header-title">
            <span v-if="tagType == 'add'">新增标题包</span>
            <span v-if="tagType == 'edit'">修改标题包</span>
            <i class="el-icon-close k-drawer-close" @click="titleFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="所属项目:" prop="pid">
            <el-select
              style="width: 100%"
              v-model="titleForm.pid"
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getProjectLists"
            >
              <el-option
                v-for="item in projects"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题包名称:" prop="name">
            <el-input placeholder="请输入账户名称" v-model="titleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="标题包备注:">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入备注内容"
              v-model="titleForm.remark"
            ></el-input>
          </el-form-item>
          <el-form-item label="标题:" prop="titles">
            <el-tag
              style="margin-right:5px"
              :key="tag"
              v-for="tag in titleForm.titles"
              closable
              :disable-transitions="false"
              @close="handleTitleClose(tag)"
            >{{tag}}</el-tag>
            <el-input
              style="width:80px"
              class="input-new-tag"
              v-if="inputTitleVisible"
              v-model="inputTitleValue"
              ref="saveTitleInput"
              @keyup.enter.native="handleInputConfirmTitle"
              @blur="handleInputConfirmTitle"
            ></el-input>
            <el-button :size="size" v-else class="button-new-tag" @click="showInputTitle">+创 建</el-button>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" v-if="tagType == 'add'" @click="addTitles" :size="size">提交</el-button>
          <el-button type="primary" v-if="tagType == 'edit'" @click="editTitles" :size="size">修改</el-button>
          <el-button :size="size" @click="titleFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      wrapper: false,
      addFormVisiable: false,
      titleFormVisiable: false,
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      loading: false,
      size: 'mini',

      nameOptions: [],
      templateOptions: [],
      titleOptions: [],
      promotion_way_options: [
        { value: 'STANDARD', label: '专业版' },
        { value: 'SIMPLE', label: '极速版' }
      ],
      marketing_goal_options: [
        { value: 'VIDEO_PROM_GOODS', label: '短视频带货' },
        { value: 'LIVE_PROM_GOODS', label: '直播带货' }
      ],
      projects: [],
      ids: [],
      searchForm: {
        promotion_way: '',
        marketing_goal: '',
        tagName: '',
        titleName: '',
        templateName: '',
        pid: ''
      },
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
      titleData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
      templateData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
      tagType: 'add',
      addForm: {
        id: '',
        pid: '',
        name: '',
        remark: '',
        dynamicTags: []
      },
      titleForm: {
        id: '',
        pid: '',
        name: '',
        remark: '',
        titles: []
      },
      inputVisible: false,
      inputValue: '',
      inputTitleVisible: false,
      inputTitleValue: '',
      rules: {
        addForm: {
          pid: [
            { required: true, message: '请选择所属项目', trigger: ['change'] }
          ],
          name: [
            {
              required: true,
              message: '请输入标签包名称',
              trigger: ['change', 'blur']
            }
          ],
          dynamicTags: [
            {
              type: 'array',
              required: true,
              message: '请至少添加一个标签',
              trigger: 'change'
            }
          ]
        },
        titleForm: {
          pid: [
            { required: true, message: '请选择所属项目', trigger: ['change'] }
          ],
          name: [
            {
              required: true,
              message: '请输入标题包名称',
              trigger: ['change', 'blur']
            }
          ],
          titles: [
            {
              type: 'array',
              required: true,
              message: '请至少添加一个标题',
              trigger: 'change'
            }
          ]
        }
      }
    }
  },
  computed: {
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  methods: {
    //删除计划模板
    delTemplate: function(row) {
      this.$confirm('此操作将删除计划模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        function() {
          this.$api.assets.delTemplate({ id: row.id }).then(res => {
            if (res.code == 0) {
              var data = this.templateData.data
              data.forEach(
                function(item, index) {
                  if (item.id == row.id) {
                    this.$delete(data, index)
                  }
                }.bind(this)
              )
              this.$message({
                showClose: true,
                message: '删除标题包成功',
                type: 'success'
              })
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'error'
              })
            }
          })
        }.bind(this)
      )
    },
    //搜索
    searchList: function() {
      var params = this.makeParams()
      this.handleSearch(params)
    },
    addTitlesOpen: function() {
      this.tagType = 'add'
      this.titleForm = { id: '', pid: '', name: '', remark: '', titles: [] }
      this.titleFormVisiable = true
      this.getProjectLists('')
    },
    //修改页面打开
    editTitlesOpen: function(id) {
      this.tagType = 'edit'
      this.titleFormVisiable = true
      this.getProjectLists('')
      this.getOneTitleInfo(id)
    },
    getOneTitleInfo: function(id) {
      this.$api.assets.titleBagGetOneInfo({ id: id }).then(res => {
        if (res.code == 0) {
          this.titleForm = res.data
        }
      })
    },
    //添加标题包
    addTitles: function() {
      this.$refs['titleForm'].validate(
        function(valid) {
          if (valid) {
            this.$api.assets.titleBagAddTitles(this.titleForm).then(res => {
              if (res.code == 0) {
                this.titleFormVisiable = false

                this.handleSearch({})
                this.$message({
                  showClose: true,
                  message: '添加标题包成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                })
              }
            })
          }
        }.bind(this)
      )
    },
    //修改标题包
    editTitles: function() {
      this.$refs['titleForm'].validate(
        function(valid) {
          if (valid) {
            this.$api.assets.titleBagEditTitles(this.titleForm).then(res => {
              if (res.code == 0) {
                this.titleFormVisiable = false

                var data = this.titleData.data
                data.forEach(
                  function(item, index) {
                    if (item.id == res.data.id) {
                      this.$set(data, index, res.data)
                    }
                  }.bind(this)
                )

                this.$message({
                  showClose: true,
                  message: '修改标题包成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                })
              }
            })
          }
        }.bind(this)
      )
    },
    delTitle: function(row) {
      this.$confirm('此操作将删除标题包, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        function() {
          this.$api.assets.titleBagDelTitle(this.titleForm).then(res => {
            if (res.code == 0) {
              var data = this.titleData.data
              data.forEach(
                function(item, index) {
                  if (item.id == row.id) {
                    this.$delete(data, index)
                  }
                }.bind(this)
              )
              this.$message({
                showClose: true,
                message: '删除标题包成功',
                type: 'success'
              })
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'error'
              })
            }
          })
        }.bind(this)
      )
    },
    //获取项目列表
    getProjectLists: function(query) {
      this.$api.assets.projectList({ name: query }).then(res => {
        if (res.code === 0) {
          this.projects = res.data
        }
      })
    },
    handleClose(tag) {
      this.addForm.dynamicTags.splice(this.addForm.dynamicTags.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue && this.addForm.dynamicTags.indexOf(inputValue) == -1) {
        this.addForm.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleTitleClose(tag) {
      this.titleForm.titles.splice(this.titleForm.titles.indexOf(tag), 1)
    },

    showInputTitle() {
      this.inputTitleVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTitleInput.$refs.input.focus()
      })
    },

    handleInputConfirmTitle() {
      let inputTitleValue = this.inputTitleValue
      if (
        inputTitleValue &&
        this.titleForm.titles.indexOf(inputTitleValue) == -1
      ) {
        this.titleForm.titles.push(inputTitleValue)
      }
      this.inputTitleVisible = false
      this.inputTitleValue = ''
    },
    //标签切换
    handleClick: function(tab, event) {
      var params = this.makeParams()

      if (tab.name == 'first') {
        this.remoteMethodTag('')
      }
      if (tab.name == 'second') {
        this.remoteMethodTitle('')
      }
      if (tab.name == 'third') {
        this.remoteMethodTemplate('')
      }

      this.handleSearch(params)
    },
    //计划模板下拉菜单
    remoteMethodTemplate: function(query) {
      this.$api.assets
        .CampaignTemplateGetList({ type: 'LIST', query: query })
        .then(res => {
          this.templateOptions = res.data
        })
    },
    //标题包下拉菜单
    remoteMethodTitle: function(query) {
      this.$api.assets
        .TitleBagGetList({ type: 'LIST', query: query })
        .then(res => {
          if (res.code == 0) {
            this.titleOptions = res.data
          }
        })
    },
    //标签包下拉菜单
    remoteMethodTag: function(query) {
      this.$api.assets.TagGetList({ type: 'LIST', query: query }).then(res => {
        if (res.code == 0) {
          this.nameOptions = res.data
        }
      })
    },
    //打开添加标签页面
    addTagsOpen: function() {
      this.tagType = 'add'
      this.addForm = { id: '', pid: '', name: '', remark: '', dynamicTags: [] }
      this.addFormVisiable = true
      this.getProjectLists('')
    },
    //修改页面打开
    editTagsOpen: function(id) {
      this.tagType = 'edit'
      this.addFormVisiable = true
      this.getProjectLists('')
      this.getOneInfo(id)
    },
    //获取一条标签包信息
    getOneInfo: function(id) {
      this.$api.assets.tagGetOneInfo({ id: id }).then(res => {
        if (res.code == 0) {
          this.addForm = res.data
        }
      })
    },
    //删除标签包
    delTag: function(row) {
      this.$confirm('此操作将删除标签包, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        function() {
          this.$api.assets.delTagFromBag({ id: row.id }).then(res => {
            if (res.code == 0) {
              var data = this.tableData.data
              data.forEach(
                function(item, index) {
                  if (item.id == row.id) {
                    this.$delete(data, index)
                  }
                }.bind(this)
              )
              this.$message({
                showClose: true,
                message: '删除标签包成功',
                type: 'success'
              })
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'error'
              })
            }
          })
        }.bind(this)
      )
    },
    //修改标签包
    editTags: function() {
      this.$refs['addForm'].validate(
        function(valid) {
          if (valid) {
            this.$api.assets.editTags(this.addForm).then(res => {
              if (res.code == 0) {
                this.addFormVisiable = false

                var data = this.tableData.data
                data.forEach(
                  function(item, index) {
                    if (item.id == res.data.id) {
                      this.$set(data, index, res.data)
                    }
                  }.bind(this)
                )
                this.$message({
                  showClose: true,
                  message: '添加标签包成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                })
              }
            })
          }
        }.bind(this)
      )
    },
    //添加标签包名称
    addTags: function() {
      this.$refs['addForm'].validate(
        function(valid) {
          if (valid) {
            this.$api.assets.addTags(this.addForm).then(res => {
              if (res.code == 0) {
                this.addFormVisiable = false

                this.handleSearch({})
                this.$message({
                  showClose: true,
                  message: '添加标签包成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                })
              }
            })
          }
        }.bind(this)
      )
    },
    // 执行查询
    doSearch: function(event) {
      var query = this.searchForm
      query['_t'] = Date.parse(new Date())

      this.$router.push({ path: this.$route.path, query: query })
    },

    // 排序
    sortChange: function(e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      }
      this.handleSearch(this.searchForm, 1, prop, order)
    },

    // 改变当前页 page
    handleCurrentChange: function(val) {
      this.handleSearch(this.searchForm, val)
    },
    //获取标签包
    getTagsInfo: function(param, page, prop, order) {
      this.$api.assets.getTagsInfo(param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data
        } else {
          var message = '查询列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },

    getTitlesInfo: function(param, page, prop, order) {
      this.$api.assets.getTitleInfo(param).then(res => {
        if (res.code === 0) {
          this.titleData = res.data
        } else {
          var message = '查询列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    getTemplatesInfo: function(param, page, prop, order) {
      this.$api.assets.getTemplateInfo(param).then(res => {
        if (res.code === 0) {
          this.templateData = res.data
        } else {
          var message = '查询列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    // 公共请求接口
    handleSearch: function(params, page, prop, order) {
      this.loading = true

      var param = Object.assign({}, params)

      param['page'] = page ? page : 1
      param['prop'] = prop ? prop : 'id'
      param['order'] = order ? order : 'desc'

      if (this.activeName == 'first') {
        this.getTagsInfo(param, page, prop, order)
      }

      if (this.activeName == 'second') {
        this.getTitlesInfo(param, page, prop, order)
      }

      if (this.activeName == 'third') {
        this.getTemplatesInfo(param, page, prop, order)
      }
    },

    // 生成查询参数
    makeParams: function(query, data) {
      var params = {}
      params['pid'] = this.searchForm.pid
      params['tagName'] = this.searchForm.tagName
      params['titleName'] = this.searchForm.titleName
      params['templateName'] = this.searchForm.templateName
      params['promotion_way'] = this.searchForm.promotion_way
      params['marketing_goal'] = this.searchForm.marketing_goal

      this.searchForm = params
      return params
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    this.getProjectLists('')
    this.remoteMethodTag('')
    var params = this.makeParams(to.query)
    this.handleSearch(params)
    next()
  },
  mounted: function() {
    this.getProjectLists('')
    this.remoteMethodTag('')
    var params = this.makeParams()
    this.handleSearch(params)
  }
}
</script>